import { Component } from '@angular/core';
import { LoginModule } from 'src/app/shared/modules/auth/login/login.module';

@Component({
    standalone: true,
    imports: [LoginModule],
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent {}
